import { render, staticRenderFns } from "./tripDetails.vue?vue&type=template&id=485a1bb6&"
import script from "./tripDetails.vue?vue&type=script&lang=js&"
export * from "./tripDetails.vue?vue&type=script&lang=js&"
import style0 from "./tripDetails.vue?vue&type=style&index=0&id=485a1bb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports